import Layout from '@layout/Index'

export const permissionGroup = [
  {
    path: '/permission-group',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'manage',
      },
      {
        path: 'manage',
        component: () => import(/* webpackChunkName: "permission-group-manage" */ './pages/PermissionGroupManage.vue'),
        name: '权限组管理',
        meta: {
          title: '权限组管理',
        },
      },
      {
        path: 'select',
        component: () => import(/* webpackChunkName: "permission-group-manage" */ './pages/PermissionGroupSelectDemo.vue'),
        name: '权限组选择DEMO',
        meta: {
          title: '权限组选择DEMO',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/permission-group/permission-group.route.js